module.exports = __webpack_public_path__ + "img/s-make-up.c39f7871.svg";